import { render } from "./addons_modal.vue?vue&type=template&id=7b50903e"
import script from "./addons_modal.vue?vue&type=script&lang=js"
export * from "./addons_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__